import Alpine from "alpinejs";
import algoliasearch from "algoliasearch/lite";

function stripEmTags(html) {
    return html.replace(/<\/?em>/g, "");
}

function algoliaAutocomplete(formEl) {
    return {
        query: "",
        results: [],
        expanded: false,
        showDropdown: false,
        searchTimeout: null,
        appId: formEl.dataset.algoliaAppId,
        apiKey: formEl.dataset.algoliaApiKey,
        anonymousKey: formEl.dataset.algoliaAnonymousKey,
        indexName: formEl.dataset.algoliaIndexName,
        isAnonymous: formEl.dataset.algoliaIsAnonymous,
        searchResultsPage: formEl.getAttribute("action"),
        activeIndex: -1,
        focusMovingToOption: false, // Track if focus is moving to dropdown option
        get activeDescendantId() {
            return this.activeIndex >= 0 ? `algolia-option-${this.activeIndex}` : null;
        },
        checkIsAnonymous() {
            if (this.isAnonymous === "true") return true;
            return false;
        },
        hideDropdown() {
            setTimeout(() => {
                if (!this.focusMovingToOption) {
                    this.showDropdown = false;
                    this.activeIndex = -1;
                }
                this.focusMovingToOption = false;
            }, 150);
        },
        async search() {
            if (!this.query || this.query.length < 1) {
                this.results = [];
                this.activeIndex = -1;
                return;
            }
            const searchClient = algoliasearch(this.appId, this.apiKey);

            try {
                const index = searchClient.initIndex(this.indexName);
                const { hits } = await index.search(this.query, { hitsPerPage: 5 });

                this.results = (hits || []).map(hit => {
                    const q = encodeURIComponent(hit.query);
                    const highlighted = hit._highlightResult?.query?.value || hit.query;
                    return {
                        objectID: hit.objectID,
                        value: hit.query,
                        highlighted: stripEmTags(highlighted),
                        url: `${this.searchResultsPage}?q=${q}`
                    };
                });
                this.activeIndex = this.results.length > 0 ? 0 : -1;
            } catch {
                this.results = [];
                this.activeIndex = -1;
                //eslint-disable-next-line no-console
                console.warn("Algolia search error");
            }
        },
        moveActive(step) {
            if (!this.results.length) return;
            if (this.activeIndex === -1) {
                this.activeIndex = 0;
                return;
            }
            this.activeIndex = (this.activeIndex + step + this.results.length) % this.results.length;
            this.scrollActiveIntoView();
        },
        selectActive() {
            if (this.results.length === 0) {
                window.location.href = `${this.searchResultsPage}?q=${encodeURIComponent(this.query)}`;
                return;
            }
            if (this.activeIndex >= 0 && this.activeIndex < this.results.length) {
                this.selectResult(this.results[this.activeIndex]);
            }
        },
        scrollActiveIntoView() {
            this.$nextTick(() => {
                const el = document.getElementById(`algolia-option-${this.activeIndex}`);
                if (el) el.scrollIntoView({ block: "nearest" });
            });
        },
        selectResult(result) {
            window.location.href = result.url || "#";
        },
        // Accessibility: Tab/Shift+Tab support
        handleInputTab(e) {
            if (this.showDropdown && this.results.length > 0 && !e.shiftKey) {
                e.preventDefault();
                this.activeIndex = 0;
                this.focusMovingToOption = true;
                this.$nextTick(() => {
                    const el = document.getElementById("algolia-option-0");
                    if (el) el.focus();
                });
            }
        },
        handleOptionTab(e, i) {
            this.focusMovingToOption = true;
            if (!e.shiftKey) {
                if (i < this.results.length - 1) {
                    e.preventDefault();
                    this.activeIndex = i + 1;
                    this.$nextTick(() => {
                        const el = document.getElementById(`algolia-option-${i + 1}`);
                        if (el) el.focus();
                    });
                } // else allow tab to move out of dropdown
            } else {
                // Shift+Tab: move focus back to input if on first option
                if (i === 0) {
                    e.preventDefault();
                    const input = formEl.querySelector("#algolia-search-input");
                    if (input) input.focus();
                } else {
                    e.preventDefault();
                    this.activeIndex = i - 1;
                    this.$nextTick(() => {
                        const el = document.getElementById(`algolia-option-${i - 1}`);
                        if (el) el.focus();
                    });
                }
            }
        }
    };
}

Alpine.data("algoliaAutocomplete", algoliaAutocomplete);
